/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "API": {
        "GraphQL": {
            "defaultAuthMode": "apiKey"
        }
    }
};


export default awsmobile;
